export const GET_ERRORS = 'GET_ERRORS';

export const ADD_ROLE = 'ADD_ROLE';
export const ADD_ROLE_START = 'ADD_ROLE_START';
export const ADD_ROLE_ERROR = 'ADD_ROLE_ERROR';

export const UPDATE_ROLE = 'UPDATE_ROLE';
export const UPDATE_ROLE_START = 'UPDATE_ROLE_START';
export const UPDATE_ROLE_ERROR = 'UPDATE_ROLE_ERROR';

export const GET_ROLE = 'GET_ROLE';
export const GET_ROLE_START = 'GET_ROLE_START';
export const GET_ROLE_ERROR = 'GET_ROLE_ERROR';

export const GET_ROLE_LIST = 'GET_ROLE_LIST';
export const GET_ROLE_LIST_START = 'GET_ROLE_LIST_START';
export const GET_ROLE_LIST_ERROR = 'GET_ROLE_LIST_ERROR';

export const GET_ROLES_HASHMAP_LIST = 'GET_ROLES_HASHMAP_LIST';
export const GET_ROLES_HASHMAP_LIST_START = 'GET_ROLES_HASHMAP_LIST_START';
export const GET_ROLES_HASHMAP_LIST_ERROR = 'GET_ROLES_HASHMAP_LIST_ERROR';

export const DELETE_ROLE = 'DELETE_ROLE';
export const DELETE_ROLE_START = 'DELETE_ROLE_START';
export const DELETE_ROLE_ERROR = 'DELETE_ROLE_ERROR';

export const GET_ROLE_DTO_LIST = 'GET_ROLE_DTO_LIST';
export const GET_ROLE_DTO_LIST_START = 'GET_ROLE_DTO_LIST_START';
export const GET_ROLE_DTO_LIST_ERROR = 'GET_ROLE_DTO_LIST_ERROR';

export const ADD_ROLE_AND_RETURN_ROLE_DTO = 'ADD_ROLE_AND_RETURN_ROLE_DTO';
export const ADD_ROLE_AND_RETURN_ROLE_DTO_START =
  'ADD_ROLE_AND_RETURN_ROLE_DTO_START';
export const ADD_ROLE_AND_RETURN_ROLE_DTO_ERROR =
  'ADD_ROLE_AND_RETURN_ROLE_DTO_ERROR';

export const CLEAR_ERROR_ROLE = 'CLEAR_ERROR_ROLE';

export const GET_ACTION_LIST = 'GET_ACTION_LIST';
export const GET_ACTION_LIST_START = 'GET_ACTION_LIST_START';
export const GET_ACTION_LIST_ERROR = 'GET_ACTION_LIST_ERROR';

export const GET_SIGNET_LIST = 'GET_SIGNET_LIST';
export const GET_SIGNET_LIST_START = 'GET_SIGNET_LIST_START';
export const GET_SIGNET_LIST_ERROR = 'GET_SIGNET_LIST_START';
export const GET_SIGNET_LIST_FILTER = 'GET_SIGNET_LIST_FILTER';
export const GET_SIGNET_LIST_FILTER_START = 'GET_SIGNET_LIST_FILTER_START';
export const GET_SIGNET_LIST_FILTER_ERROR = 'GET_SIGNET_LIST_FILTER_ERROR';
export const UPDATE_SIGNET_STATUS = 'UPDATE_SIGNET_STATUS';
export const UPDATE_SIGNET_STATUS_START = 'UPDATE_SIGNET_STATUS_START';
export const UPDATE_SIGNET_STATUS_ERROR = 'UPDATE_SIGNET_STATUS_ERROR';
export const GET_SIGNET = 'GET_SIGNET';
export const GET_SIGNET_START = 'GET_SIGNET_START';
export const GET_SIGNET_ERROR = 'GET_SIGNET_ERROR';

export const DOWNLOAD_EXAMPLE_SIGNET = 'DOWNLOAD_EXAMPLE_SIGNET';
export const DOWNLOAD_EXAMPLE_SIGNET_START = 'DOWNLOAD_EXAMPLE_SIGNET_START';
export const DOWNLOAD_EXAMPLE_SIGNET_ERROR = 'DOWNLOAD_EXAMPLE_SIGNET_ERROR';

export const GET_SIGNET_EXAMPLE_LIST_PAGEABLE =
  'GET_SIGNET_EXAMPLE_LIST_PAGEABLE';
export const GET_SIGNET_EXAMPLE_LIST_START = 'GET_SIGNET_EXAMPLE_LIST_START';
export const GET_SIGNET_EXAMPLE_LIST_ERROR = 'GET_SIGNET_EXAMPLE_LIST_ERROR';
export const ADD_SIGNET_EXAMPLE = 'ADD_SIGNET_EXAMPLE';
export const ADD_SIGNET_EXAMPLE_START = 'ADD_SIGNET_EXAMPLE_START';
export const ADD_SIGNET_EXAMPLE_ERROR = 'ADD_SIGNET_EXAMPLE_ERROR';

export const ADD_USER = 'ADD_USER';
export const ADD_USER_START = 'ADD_USER_START';
export const ADD_USER_ERROR = 'ADD_USER_ERROR';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_START = 'UPDATE_USER_START';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const GET_USER = 'GET_USER';
export const GET_USER_START = 'GET_USER_START';
export const GET_USER_ERROR = 'GET_USER_ERROR';

export const GET_USER_LIST_PAGEABLE = 'GET_USER_LIST_PAGEABLE';

export const GET_USER_LIST = 'GET_USER_LIST';
export const GET_USER_LIST_START = 'GET_USER_LIST_START';
export const GET_USER_LIST_ERROR = 'GET_USER_LIST_ERROR';

export const DEACTIVATE_USER = 'DEACTIVATE_USER';
export const DEACTIVATE_USER_START = 'DEACTIVATE_USER_START';
export const DEACTIVATE_USER_ERROR = 'DEACTIVATE_USER_ERROR';

export const ACTIVATE_USER = 'ACTIVATE_USER';
export const ACTIVATE_USER_START = 'ACTIVATE_USER_START';
export const ACTIVATE_USER_ERROR = 'ACTIVATE_USER_ERROR';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_START = 'DELETE_USER_START';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';

export const CLEAR_ERROR_USER = 'CLEAR_ERROR_USER';

export const SET_LOGGED_USER = 'SET_LOGGED_USER';
export const SET_LOGGED_USER_START = 'SET_LOGGED_USER_START';
export const SET_LOGGED_USER_ERROR = 'SET_LOGGED_USER_ERROR';

export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const ADD_DECISION = 'ADD_DECISION';
export const ADD_DECISION_START = 'ADD_DECISION_START';
export const ADD_DECISION_ERROR = 'ADD_DECISION_ERROR';

export const UPDATE_DECISION = 'UPDATE_DECISION';
export const UPDATE_DECISION_START = 'UPDATE_DECISION_START';
export const UPDATE_DECISION_ERROR = 'UPDATE_DECISION_ERROR';

export const GET_DECISION = 'GET_DECISION';
export const GET_DECISION_START = 'GET_DECISION_START';
export const GET_DECISION_ERROR = 'GET_DECISION_ERROR';

export const GET_DECISION_BY_REQUEST = 'GET_DECISION_BY_REQUEST';
export const GET_DECISION_BY_REQUEST_START = 'GET_DECISION_BY_REQUEST_START';
export const GET_DECISION_BY_REQUEST_ERROR = 'GET_DECISION_BY_REQUEST_ERROR';

export const GET_DECISION_LIST = 'GET_DECISION_LIST';
export const GET_DECISION_LIST_PAGEABLE = 'GET_DECISION_LIST_PAGEABLE';
export const GET_DECISION_LIST_START = 'GET_DECISION_LIST_START';
export const GET_DECISION_LIST_ERROR = 'GET_DECISION_LIST_ERROR';

export const DELETE_DECISION = 'DELETE_DECISION';
export const DELETE_DECISION_START = 'DELETE_DECISION_START';
export const DELETE_DECISION_ERROR = 'DELETE_DECISION_ERROR';

export const CHANGE_STATUS_DECISION = 'CHANGE_STATUS_DECISION';
export const CHANGE_STATUS_DECISION_START = 'CHANGE_STATUS_DECISION_START';
export const CHANGE_STATUS_DECISION_ERROR = 'CHANGE_STATUS_DECISION_ERROR';

export const CLEAR_ERROR_DECISION = 'CLEAR_ERROR_DECISION';

export const ADD_DECISION_TYPE = 'ADD_DECISION_TYPE';
export const ADD_DECISION_TYPE_START = 'ADD_DECISION_TYPE_START';
export const ADD_DECISION_TYPE_ERROR = 'ADD_DECISION_TYPE_ERROR';

export const UPDATE_DECISION_TYPE = 'UPDATE_DECISION_TYPE';
export const UPDATE_DECISION_TYPE_START = 'UPDATE_DECISION_TYPE_START';
export const UPDATE_DECISION_TYPE_ERROR = 'UPDATE_DECISION_TYPE_ERROR';

export const GET_DECISION_TYPE = 'GET_DECISION_TYPE';
export const GET_DECISION_TYPE_START = 'GET_DECISION_TYPE_START';
export const GET_DECISION_TYPE_ERROR = 'GET_DECISION_TYPE_ERROR';

export const GET_DECISION_TYPE_LIST = 'GET_DECISION_TYPE_LIST';
export const GET_DECISION_TYPE_LIST_PAGEABLE =
  'GET_DECISION_TYPE_LIST_PAGEABLE';
export const GET_DECISION_TYPE_LIST_START = 'GET_DECISION_TYPE_LIST_START';
export const GET_DECISION_TYPE_LIST_ERROR = 'GET_DECISION_TYPE_LIST_ERROR';

export const DELETE_DECISION_TYPE = 'DELETE_DECISION_TYPE';
export const DELETE_DECISION_TYPE_START = 'DELETE_DECISION_TYPE_START';
export const DELETE_DECISION_TYPE_ERROR = 'DELETE_DECISION_TYPE_ERROR';

export const CLEAR_ERROR_DECISION_TYPE = 'CLEAR_ERROR_DECISION_TYPE';

export const GET_DECISION_TYPE_ATTACHMENT = 'GET_DECISION_TYPE_ATTACHMENT';
export const GET_DECISION_TYPE_ATTACHMENT_START =
  'GET_DECISION_TYPE_ATTACHMENT_START';
export const GET_DECISION_TYPE_ATTACHMENT_ERROR =
  'GET_DECISION_TYPE_ATTACHMENT_ERROR';

export const CHANGE_DECISION_STATUS = 'CHANGE_DECISION_STATUS';
export const CHANGE_DECISION_STATUS_START = 'CHANGE_DECISION_STATUS_START';
export const CHANGE_DECISION_STATUS_ERROR = 'CHANGE_DECISION_STATUS_ERROR';

export const CLEAR_ERROR_DECISION_TYPE_ATTACHMENT =
  'CLEAR_ERROR_DECISION_TYPE_ATTACHMENT';

export const ADD_DECISION_TYPE_ATTACHMENT = 'ADD_DECISION_TYPE_ATTACHMENT';
export const ADD_DECISION_TYPE_ATTACHMENT_START =
  'ADD_DECISION_TYPE_ATTACHMENT_START';
export const ADD_DECISION_TYPE_ATTACHMENT_ERROR =
  'ADD_DECISION_TYPE_ATTACHMENT_ERROR';

export const GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW =
  'GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW';
export const GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_START =
  'GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_START';
export const GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_ERROR =
  'GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_ERROR';
export const GET_DECISION_TYPE_ATTACHMENT_LIST =
  'GET_DECISION_TYPE_ATTACHMENT_LIST';
export const GET_DECISION_TYPE_ATTACHMENT_LIST_ERROR =
  'GET_DECISION_TYPE_ATTACHMENT_LIST_ERROR';
export const GET_DECISION_TYPE_ATTACHMENT_LIST_START =
  'GET_DECISION_TYPE_ATTACHMENT_LIST_START';
export const GET_DECISION_TYPE_ATTACHMENT_LIST_PAGEABLE =
  'GET_DECISION_TYPE_ATTACHMENT_LIST_PAGEABLE';

export const REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT';

//SUBMISSION DATA SIGNET

export const ADD_SUBMISSION_DATA_SIGNET = 'ADD_SUBMISSION_DATA_SIGNET';
export const ADD_SUBMISSION_DATA_SIGNET_START =
  'ADD_SUBMISSION_DATA_SIGNET_START';
export const ADD_SUBMISSION_DATA_SIGNET_ERROR =
  'ADD_SUBMISSION_DATA_SIGNET_ERROR';

export const CLEAR_ERROR_SUBMISSION_DATA_SIGNET =
  'CLEAR_ERROR_SUBMISSION_DATA_SIGNET';
export const ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK =
  'ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK';
export const ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_START =
  'ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_START';
export const ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_ERROR =
  'ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_ERROR';

//SUBMISSION DATA SIGNET LOOK

export const ADD_SUBMISSION_DATA_SIGNET_LOOK =
  'ADD_SUBMISSION_DATA_SIGNET_LOOK';
export const ADD_SUBMISSION_DATA_SIGNET_LOOK_START =
  'ADD_SUBMISSION_DATA_SIGNET_LOOK_START';
export const ADD_SUBMISSION_DATA_SIGNET_LOOK_ERROR =
  'ADD_SUBMISSION_DATA_SIGNET_LOOK_ERROR';

export const GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW =
  'GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW';
export const GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_START =
  'GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_START';
export const GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_ERROR =
  'GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_ERROR';

export const GET_SUBMISSION_DATA_SIGNET_LOOK_LIST =
  'GET_SUBMISSION_DATA_SIGNET_LOOK_LIST';
export const GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_ERROR =
  'GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_ERROR';
export const GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_START =
  'GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_START';
export const GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_PAGEABLE =
  'GET_SUBMISSION_DATA_SIGNET_LOOK_LIST_PAGEABLE';

export const REMOVE_SUBMISSION_DATA_SIGNET_LOOK =
  'REMOVE_SUBMISSION_DATA_SIGNET_LOOK';

export const CLEAR_ERROR_SUBMISSION_DATA_SIGNET_LOOK =
  'CLEAR_ERROR_SUBMISSION_DATA_SIGNET_LOOK';

export const GET_SUBMISSION_DATA_SIGNET_LOOK =
  'GET_SUBMISSION_DATA_SIGNET_LOOK';
export const GET_SUBMISSION_DATA_SIGNET_LOOK_START =
  'GET_SUBMISSION_DATA_SIGNET_LOOK_START';
export const GET_SUBMISSION_DATA_SIGNET_LOOK_ERROR =
  'GET_SUBMISSION_DATA_SIGNET_LOOK_ERROR';

export const GET_SUBMISSION_DATA_SIGNET_BY_SIGNET =
  'GET_SUBMISSION_DATA_SIGNET_BY_SIGNET';
export const GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_START =
  'GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_START';
export const GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_ERROR =
  'GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_ERROR';

//SUBMISSION DATA SIGNET DESTROYED
export const ADD_SUBMISSION_DATA_SIGNET_DESTROYED =
  'ADD_SUBMISSION_DATA_SIGNET_DESTROYED';
export const ADD_SUBMISSION_DATA_SIGNET_DESTROYED_START =
  'ADD_SUBMISSION_DATA_SIGNET_DESTROYED_START';
export const ADD_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR =
  'ADD_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR';

export const GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW =
  'GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW';
export const GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_START =
  'GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_START';
export const GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_ERROR =
  'GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_ERROR';
export const GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST =
  'GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST';
export const GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_ERROR =
  'GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_ERROR';
export const GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_START =
  'GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_START';
export const GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_PAGEABLE =
  'GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_PAGEABLE';

export const REMOVE_SUBMISSION_DATA_SIGNET_DESTROYED =
  'REMOVE_SUBMISSION_DATA_SIGNET_DESTROYED';

export const CLEAR_ERROR_SUBMISSION_DATA_SIGNET_DESTROYED =
  'CLEAR_ERROR_SUBMISSION_DATA_SIGNET_DESTROYED';

export const GET_SUBMISSION_DATA_SIGNET_DESTROYED =
  'GET_SUBMISSION_DATA_SIGNET_DESTROYED';
export const GET_SUBMISSION_DATA_SIGNET_DESTROYED_START =
  'GET_SUBMISSION_DATA_SIGNET_DESTROYED_START';
export const GET_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR =
  'GET_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR';
export const ADD_DECISION_ATTACHMENT = 'ADD_DECISION_ATTACHMENT';
export const ADD_DECISION_ATTACHMENT_START = 'ADD_DECISION_ATTACHMENT_START';
export const ADD_DECISION_ATTACHMENT_ERROR = 'ADD_DECISION_ATTACHMENT_ERROR';

export const GET_DECISION_ATTACHMENT = 'GET_DECISION_ATTACHMENT';
export const GET_DECISION_ATTACHMENT_START = 'GET_DECISION_ATTACHMENT_START';
export const GET_DECISION_ATTACHMENT_ERROR = 'GET_DECISION_ATTACHMENT_ERROR';

export const GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW =
  'GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW';
export const GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW_START =
  'GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW_START';
export const GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW_ERROR =
  'GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW_ERROR';

export const CLEAR_ERROR_DECISION_ATTACHMENT =
  'CLEAR_ERROR_DECISION_ATTACHMENT';

export const GET_DECISION_ATTACHMENT_LIST = 'GET_DECISION_ATTACHMENT_LIST';
export const GET_DECISION_ATTACHMENT_LIST_START =
  'GET_DECISION_ATTACHMENT_LIST_START';
export const GET_DECISION_ATTACHMENT_LIST_ERROR =
  'GET_DECISION_ATTACHMENT_LIST_ERROR';

export const GET_DECISION_ATTACHMENT_LIST_PAGEABLE =
  'GET_DECISION_ATTACHMENT_LIST_PAGEABLE';

export const GET_ALLOWED_ACTIONS_START = 'GET_ALLOWED_ACTIONS_START';
export const GET_ALLOWED_ACTIONS_SUCCESSFULLY =
  'GET_ALLOWED_ACTIONS_SUCCESSFULLY';
export const GET_ALLOWED_ACTIONS_ERROR = 'GET_ALLOWED_ACTIONS_ERROR';

export const ADD_REQUEST_FOR_SIGNET_APPROVAL =
  'ADD_REQUEST_FOR_SIGNET_APPROVAL';
export const ADD_REQUEST_FOR_SIGNET_APPROVAL_START =
  'ADD_REQUEST_FOR_SIGNET_APPROVAL_START';
export const ADD_REQUEST_FOR_SIGNET_APPROVAL_ERROR =
  'ADD_REQUEST_FOR_SIGNET_APPROVAL_ERROR';

export const UPDATE_REQUEST_FOR_SIGNET_APPROVAL =
  'UPDATE_REQUEST_FOR_SIGNET_APPROVAL';
export const UPDATE_REQUEST_FOR_SIGNET_APPROVAL_START =
  'UPDATE_REQUEST_FOR_SIGNET_APPROVAL_START';
export const UPDATE_REQUEST_FOR_SIGNET_APPROVAL_ERROR =
  'UPDATE_REQUEST_FOR_SIGNET_APPROVAL_ERROR';

export const GET_REQUEST_FOR_SIGNET_APPROVAL =
  'GET_REQUEST_FOR_SIGNET_APPROVAL';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_START =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_START';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_ERROR =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_ERROR';

export const GET_REQUEST_FOR_SIGNET_APPROVAL_LIST =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_LIST';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_PAGEABLE =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_PAGEABLE';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_START =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_START';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_ERROR =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_ERROR';

export const DELETE_REQUEST_FOR_SIGNET_APPROVAL =
  'DELETE_REQUEST_FOR_SIGNET_APPROVAL';
export const DELETE_REQUEST_FOR_SIGNET_APPROVAL_START =
  'DELETE_REQUEST_FOR_SIGNET_APPROVAL_START';
export const DELETE_REQUEST_FOR_SIGNET_APPROVAL_ERROR =
  'DELETE_REQUEST_FOR_SIGNET_APPROVAL_ERROR';

export const CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS =
  'CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS';
export const CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_START =
  'CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_START';
export const CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_ERROR =
  'CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_ERROR';
//AUTONOMUS PROVINCE
export const GET_AUTONOMOUS_PROVINCE_LIST_START =
  'GET_AUTONOMOUS_PROVINCE_LIST_START';
export const GET_AUTONOMOUS_PROVINCE_LIST = 'GET_AUTONOMOUS_PROVINCE_LIST';
export const GET_AUTONOMOUS_PROVINCE_LIST_ERROR =
  'GET_AUTONOMOUS_PROVINCE_LIST_ERROR';

//PLACE
export const GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_START =
  'GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_START';
export const GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE =
  'GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE';
export const GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_ERROR =
  'GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_ERROR';

export const GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_START =
  'GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_START';
export const GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE =
  'GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE';
export const GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_ERROR =
  'GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_ERROR';

export const GET_PLACE_LIST_START = 'GET_PLACE_LIST_START';
export const GET_PLACE_LIST = 'GET_PLACE_LIST';
export const GET_PLACE_LIST_ERROR = 'GET_PLACE_LIST_ERROR';

export const GET_PLACE_FILTER_LIST_START = 'GET_PLACE_FILTER_LIST_START';
export const GET_PLACE_FILTER_LIST = 'GET_PLACE_FILTER_LIST';
export const GET_PLACE_FILTER_LIST_ERROR = 'GET_PLACE_FILTER_LIST_ERROR';

export const GET_PLACE_LIST_PAGEBALE_START = 'GET_PLACE_LIST_PAGEBALE_START';
export const GET_PLACE_LIST_PAGEBALE = 'GET_PLACE_LIST_PAGEBALE';
export const GET_PLACE_LIST_PAGEBALE_ERROR = 'GET_PLACE_LIST_PAGEBALE_ERROR';

export const UPDATE_PLACE_START = 'UPDATE_PLACE_START';
export const UPDATE_PLACE = 'UPDATE_PLACE';
export const UPDATE_PLACE_ERROR = 'UPDATE_PLACE_ERROR';

export const CREATE_PLACE_START = 'CREATE_PLACE_START';
export const CREATE_PLACE = 'CREATE_PLACE';
export const CREATE_PLACE_ERROR = 'CREATE_PLACE_ERROR';

export const CLEAR_PLACE_LIST = 'CLEAR_PLACE_LIST';

//MUNICIPALITY
export const GET_MUNICIPALITY_LIST_START = 'GET_MUNICIPALITY_LIST_START';
export const GET_MUNICIPALITY_LIST = 'GET_MUNICIPALITY_LIST';
export const GET_MUNICIPALITY_LIST_ERROR = 'GET_MUNICIPALITY_LIST_ERROR';

export const GET_MUNICIPALITY_LIST_BY_PLACE_START =
  'GET_MUNICIPALITY_LIST_BY_PLACE_START';
export const GET_MUNICIPALITY_LIST_BY_PLACE = 'GET_MUNICIPALITY_LIST_BY_PLACE';
export const GET_MUNICIPALITY_LIST_BY_PLACE_ERROR =
  'GET_MUNICIPALITY_LIST_BY_PLACE_ERROR';

export const CLEAR_MUNICIPALITY_LIST = 'CLEAR_MUNICIPALITY_LIST';

//KJS
export const GET_KJS_LIST_START = 'GET_KJS_LIST_START';
export const GET_KJS_LIST = 'GET_KJS_LIST';
export const GET_KJS_LIST_ERROR = 'GET_KJS_LIST_ERROR';

export const GET_KJS_LIST_BY_INSTITUTION_TYPE =
  'GET_KJS_LIST_BY_INSTITUTION_TYPE';
export const GET_KJS_LIST_BY_INSTITUTION_TYPE_START =
  'GET_KJS_LIST_BY_INSTITUTION_TYPE_START';
export const GET_KJS_LIST_BY_INSTITUTION_TYPE_ERROR =
  'GET_KJS_LIST_BY_INSTITUTION_TYPE_ERROR';

export const GET_KJS_LIST_BY_MUNICIPALITY = 'GET_KJS_LIST_BY_MUNICIPALITY';
export const GET_KJS_LIST_BY_MUNICIPALITY_START =
  'GET_KJS_LIST_BY_MUNICIPALITY_START';
export const GET_KJS_LIST_BY_MUNICIPALITY_ERROR =
  'GET_KJS_LIST_BY_MUNICIPALITY_ERROR';

export const ADD_MUNICIPALITY = 'ADD_MUNICIPALITY';
export const ADD_MUNICIPALITY_START = 'ADD_MUNICIPALITY_START';
export const ADD_MUNICIPALITY_ERROR = 'ADD_MUNICIPALITY_ERROR';

export const UPDATE_MUNICIPALITY = 'UPDATE_MUNICIPALITY';
export const UPDATE_MUNICIPALITY_START = 'UPDATE_MUNICIPALITY_START';
export const UPDATE_MUNICIPALITY_ERROR = 'UPDATE_MUNICIPALITY_ERROR';

export const GET_MUNICIPALITY_LIST_PAGEABLE = 'GET_MUNICIPALITY_LIST_PAGEABLE';
export const GET_MUNICIPALITY_LIST_PAGEABLE_START =
  'GET_MUNICIPALITY_LIST_PAGEABLE_START';
export const GET_MUNICIPALITY_LIST_PAGEABLE_ERROR =
  'GET_MUNICIPALITY_LIST_PAGEABLE_ERROR';
export const GET_MUNICIPALITY_FILTER_LIST = 'GET_MUNICIPALITY_FILTER_LIST';
export const GET_MUNICIPALITY_FILTER_LIST_START =
  'GET_MUNICIPALITY_FILTER_LIST_START';
export const GET_MUNICIPALITY_FILTER_LIST_ERROR =
  'GET_MUNICIPALITY_FILTER_LIST_ERROR';

export const GET_KJS_LIST_PAGEBALE = 'GET_KJS_LIST_PAGEBALE';
export const GET_KJS_LIST_PAGEBALE_START = 'GET_KJS_LIST_PAGEBALE_START';
export const GET_KJS_LIST_PAGEBALE_ERROR = 'GET_KJS_LIST_PAGEBALE_ERROR';

export const GET_KJS_FILTER_LIST = 'GET_KJS_FILTER_LIST';
export const GET_KJS_FILTER_LIST_START = 'GET_KJS_FILTER_LIST_START';
export const GET_KJS_FILTER_LIST_ERROR = 'GET_KJS_FILTER_LIST_ERROR';

export const CLEAR_KJS_LIST = 'CLEAR_KJS_LIST';

export const UPDATE_KJS = 'UPDATE_KJS';
export const UPDATE_KJS_START = 'UPDATE_KJS_START';
export const UPDATE_KJS_ERROR = 'UPDATE_KJS_ERROR';

//INSTITUTION_TYPE
export const GET_INSTITUTION_TYPE_LIST_START =
  'GET_INSTITUTION_TYPE_LIST_START';
export const GET_INSTITUTION_TYPE_LIST = 'GET_INSTITUTION_TYPE_LIST';
export const GET_INSTITUTION_TYPE_LIST_ERROR =
  'GET_INSTITUTION_TYPE_LIST_ERROR';
export const ADD_REQUEST_FOR_SIGNET = 'ADD_REQUEST_FOR_SIGNET';
export const ADD_REQUEST_FOR_SIGNET_START = 'ADD_REQUEST_FOR_SIGNET_START';
export const ADD_REQUEST_FOR_SIGNET_ERROR = 'ADD_REQUEST_FOR_SIGNET_ERROR';

export const UPDATE_REQUEST_FOR_SIGNET = 'UPDATE_REQUEST_FOR_SIGNET';
export const UPDATE_REQUEST_FOR_SIGNET_START =
  'UPDATE_REQUEST_FOR_SIGNET_START';
export const UPDATE_REQUEST_FOR_SIGNET_ERROR =
  'UPDATE_REQUEST_FOR_SIGNET_ERROR';

export const GET_REQUEST_FOR_SIGNET = 'GET_REQUEST_FOR_SIGNET';
export const GET_REQUEST_FOR_SIGNET_START = 'GET_REQUEST_FOR_SIGNET_START';
export const GET_REQUEST_FOR_SIGNET_ERROR = 'GET_REQUEST_FOR_SIGNET_ERROR';

export const GET_REQUEST_FOR_SIGNET_LIST = 'GET_REQUEST_FOR_SIGNET_LIST';
export const GET_REQUEST_FOR_SIGNET_LIST_PAGEABLE =
  'GET_REQUEST_FOR_SIGNET_LIST_PAGEABLE';
export const GET_REQUEST_FOR_SIGNET_LIST_START =
  'GET_REQUEST_FOR_SIGNET_LIST_START';
export const GET_REQUEST_FOR_SIGNET_LIST_ERROR =
  'GET_REQUEST_FOR_SIGNET_LIST_ERROR';

export const DELETE_REQUEST_FOR_SIGNET = 'DELETE_REQUEST_FOR_SIGNET';
export const DELETE_REQUEST_FOR_SIGNET_START =
  'DELETE_REQUEST_FOR_SIGNET_START';
export const DELETE_REQUEST_FOR_SIGNET_ERROR =
  'DELETE_REQUEST_FOR_SIGNET_ERROR';

export const CLEAR_ERROR_REQUEST_FOR_SIGNET = 'CLEAR_ERROR_REQUEST_FOR_SIGNET';

export const CLEAR_LOOK_CONTETNT = 'CLEAR_LOOK_CONTETNT';

//COMPLEMENT REQUEST APPROVAL

export const ADD_COMPLEMENT_REQUEST_APPROVAL =
  'ADD_COMPLEMENT_REQUEST_APPROVAL';
export const ADD_COMPLEMENT_REQUEST_APPROVAL_START =
  'ADD_COMPLEMENT_REQUEST_APPROVAL_START';
export const ADD_COMPLEMENT_REQUEST_APPROVAL_ERROR =
  'ADD_COMPLEMENT_REQUEST_APPROVAL_ERROR';

export const UPDATE_COMPLEMENT_REQUEST_APPROVAL =
  'UPDATE_COMPLEMENT_REQUEST_APPROVAL';
export const UPDATE_COMPLEMENT_REQUEST_APPROVAL_START =
  'UPDATE_COMPLEMENT_REQUEST_APPROVAL_START';
export const UPDATE_COMPLEMENT_REQUEST_APPROVAL_ERROR =
  'UPDATE_COMPLEMENT_REQUEST_APPROVAL_ERROR';

export const GET_COMPLEMENT_REQUEST_APPROVAL =
  'GET_COMPLEMENT_REQUEST_APPROVAL';
export const GET_COMPLEMENT_REQUEST_APPROVAL_START =
  'GET_COMPLEMENT_REQUEST_APPROVAL_START';
export const GET_COMPLEMENT_REQUEST_APPROVAL_ERROR =
  'GET_COMPLEMENT_REQUEST_APPROVAL_ERROR';

export const CLEAR_COMPLEMENT_REQUEST_APPROVAL =
  'CLEAR_COMPLEMENT_REQUEST_APPROVAL';

export const GET_COMPLEMENT_REQUEST_APPROVAL_LAST =
  'GET_COMPLEMENT_REQUEST_APPROVAL_LAST';
export const GET_COMPLEMENT_REQUEST_APPROVAL_LAST_START =
  'GET_COMPLEMENT_REQUEST_APPROVAL_LAST_START';
export const GET_COMPLEMENT_REQUEST_APPROVAL_LAST_ERROR =
  'GET_COMPLEMENT_REQUEST_APPROVAL_LAST_ERROR';

export const GET_COMPLEMENT_REQUEST_APPROVAL_LIST =
  'GET_COMPLEMENT_REQUEST_APPROVAL_LIST';
export const GET_COMPLEMENT_REQUEST_APPROVAL_LIST_START =
  'GET_COMPLEMENT_REQUEST_APPROVAL_LIST_START';
export const GET_COMPLEMENT_REQUEST_APPROVAL_LIST_ERROR =
  'GET_COMPLEMENT_REQUEST_APPROVAL_LIST_ERROR';

export const GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST =
  'GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST';
export const GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_START =
  'GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_START';
export const GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_ERROR =
  'GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_ERROR';

export const SET_PROCCESOR_FOR_REQUEST_APPROVAL =
  'SET_PROCCESOR_FOR_REQUEST_APPROVAL';
export const SET_PROCCESOR_FOR_REQUEST_APPROVAL_START =
  'SET_PROCCESOR_FOR_REQUEST_APPROVAL_START';
export const SET_PROCCESOR_FOR_REQUEST_APPROVAL_ERROR =
  'SET_PROCCESOR_FOR_REQUEST_APPROVAL_ERROR';

export const GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_START =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_START';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_ERROR =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_ERROR';

export const DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT =
  'DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT';
export const DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_START =
  'DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_START';
export const DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_ERROR =
  'DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_ERROR';

export const DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_PROPOSAL_SOLUTION =
  'DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_PROPOSAL_SOLUTION';
export const DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_PROPOSAL_SOLUTION_START =
  'DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_PROPOSAL_SOLUTION_START';
export const DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_PROPOSAL_SOLUTION_ERROR =
  'DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_PROPOSAL_SOLUTION_ERROR';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST =
  '  GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_START =
  '  GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_START';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_ERROR =
  '  GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_ERROR';

export const GET_USER_ALLOWED_ACTIONS_LIST = 'GET_USER_ALLOWED_ACTIONS_LIST';
export const GET_USER_ALLOWED_ACTIONS_LIST_ERROR =
  'GET_USER_ALLOWED_ACTIONS_LIST_ERROR';
export const CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER =
  'CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER';
export const CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_START =
  'CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_START';
export const CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_ERROR =
  'CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_ERROR';

export const GET_DECISION_FILTER_LIST = '  GET_DECISION_FILTER_LIST';
export const GET_DECISION_FILTER_LIST_START =
  '  GET_DECISION_FILTER_LIST_START';
export const GET_DECISION_FILTER_LIST_ERROR =
  '  GET_DECISION_FILTER_LIST_ERROR';

export const GET_ATTACHMENT = 'GET_ATTACHMENT';
export const GET_ATTACHMENT_START = 'GET_ATTACHMENT_START';
export const GET_ATTACHMENT_ERROR = 'GET_ATTACHMENT_ERROR';
export const CLEAR_ATTACHMENT = 'CLEAR_ATTACHMENT';

export const GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_START =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_START';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_ERROR =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_ERROR';

export const GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_START =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_START';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_ERROR =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_ERROR';

export const GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_PAGEABLE =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_PAGEABLE';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_START =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_START';
export const GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_ERROR =
  'GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_ERROR';

//COMPLEMENT SIGNET

export const ADD_COMPLEMENT_SIGNET = 'ADD_COMPLEMENT_SIGNET';
export const ADD_COMPLEMENT_SIGNET_START = 'ADD_COMPLEMENT_SIGNET_START';
export const ADD_COMPLEMENT_SIGNET_ERROR = 'ADD_COMPLEMENT_SIGNET_ERROR';

export const UPDATE_COMPLEMENT_SIGNET = 'UPDATE_COMPLEMENT_SIGNET';
export const UPDATE_COMPLEMENT_SIGNET_START = 'UPDATE_COMPLEMENT_SIGNET_START';
export const UPDATE_COMPLEMENT_SIGNET_ERROR = 'UPDATE_COMPLEMENT_SIGNET_ERROR';

export const GET_COMPLEMENT_SIGNET_LAST = 'GET_COMPLEMENT_SIGNET_LAST';
export const GET_COMPLEMENT_SIGNET_LAST_START =
  'GET_COMPLEMENT_SIGNET_LAST_START';
export const GET_COMPLEMENT_SIGNET_LAST_ERROR =
  'GET_COMPLEMENT_SIGNET_LAST_ERROR';

export const GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET =
  'GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET';
export const GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_START =
  'GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_START';
export const GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_ERROR =
  'GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_ERROR';

export const CLEAR_COMPLEMENT_SINGET = 'CLEAR_COMPLEMENT_SINGET';

export const DOWNLOAD_SIGNET_ATTACHMENT_START =
  'DOWNLOAD_SIGNET_ATTACHMENT_START';
export const DOWNLOAD_SIGNET_ATTACHMENT_ERROR =
  'DOWNLOAD_SIGNET_ATTACHMENT_ERROR';

export const GET_SIGNET_BY_CLIENT_LIST = 'GET_SIGNET_BY_CLIENT_LIST';
export const GET_SIGNET_BY_CLIENT_LIST_START =
  'GET_SIGNET_BY_CLIENT_LIST_START';
export const GET_SIGNET_BY_CLIENT_LIST_ERROR =
  'GET_SIGNET_BY_CLIENT_LIST_ERROR';

//REQUEST FOR  SIGNET STATUS

export const ADD_REQUEST_FOR_SIGNET_STATUS = 'ADD_REQUEST_FOR_SIGNET_STATUS';
export const ADD_REQUEST_FOR_SIGNET_STATUS_START =
  'ADD_REQUEST_FOR_SIGNET_STATUS_START';
export const ADD_REQUEST_FOR_SIGNET_STATUS_ERROR =
  'ADD_REQUEST_FOR_SIGNET_STATUS_ERROR';

export const GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET =
  'GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET';
export const GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_START =
  'GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_START';
export const GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ERROR =
  'GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ERROR';

export const GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT =
  'GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT';
export const GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_START =
  'GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_START';
export const GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_ERROR =
  'GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_ERROR';

export const CLEAR_ATTACHMENT_REQUEST_FOR_SIGNET_STATUS =
  'CLEAR_ATTACHMENT_REQUEST_FOR_SIGNET_STATUS';

export const VALIDATE_REQUEST_FOR_SIGNET_STATUS =
  'VALIDATE_REQUEST_FOR_SIGNET_STATUS';
export const VALIDATE_REQUEST_FOR_SIGNET_STATUS_START =
  'VALIDATE_REQUEST_FOR_SIGNET_STATUS_START';
export const VALIDATE_REQUEST_FOR_SIGNET_STATUS_ERROR =
  'VALIDATE_REQUEST_FOR_SIGNET_STATUS_ERROR';

export const ADD_USER_PROTENANT = 'ADD_USER_PROTENANT';
export const ADD_USER_PROTENANT_START = 'ADD_USER_PROTENANT_START';
export const ADD_USER_PROTENANT_ERROR = 'ADD_USER_PROTENANT_ERROR';

export const GET_LOGGED_IN_USER = 'GET_LOGGED_IN_USER';
export const GET_LOGGED_IN_USER_START = 'GET_LOGGED_IN_USER_START';
export const GET_LOGGED_IN_USER_ERROR = 'GET_LOGGED_IN_USER_ERROR';

export const GET_INSTRUCTION = 'GET_INSTRUCTION';
export const GET_INSTRUCTION_START = 'GET_INSTRUCTION_START';
export const GET_INSTRUCTION_ERROR = 'GET_INSTRUCTION_ERROR';

export const ADD_MUNICIPALITY_TO_KJS = 'ADD_MUNICIPALITY_TO_KJS';
export const ADD_MUNICIPALITY_TO_KJS_START = 'ADD_MUNICIPALITY_TO_KJS_START';
export const ADD_MUNICIPALITY_TO_KJS_ERROR = 'ADD_MUNICIPALITY_TO_KJS_ERROR';
export const UPDATE_MUNICIPALITY_WITH_KJS = 'UPDATE_MUNICIPALITY_WITH_KJS';
export const UPDATE_MUNICIPALITY_WITH_KJS_START =
  'UPDATE_MUNICIPALITY_WITH_KJS_START';
export const UPDATE_MUNICIPALITY_WITH_KJS_ERROR =
  'UPDATE_MUNICIPALITY_WITH_KJS_ERROR';
export const FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE =
  'FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE';
export const FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_START =
  'FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_START';
export const FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_ERROR =
  'FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_ERROR';
export const FIND_ALL_KJS_WITH_MUNICIPALITY_FILTER_PAGEABLE =
  'FIND_ALL_KJS_WITH_MUNICIPALITY_FILTER_PAGEABLE';
export const FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS =
  'FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS';
export const FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_START =
  'FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_START';
export const FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_ERROR =
  'FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_ERROR';
export const FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER =
  'FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER';
export const FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER_START =
  'FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER_START';
export const FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER_ERROR =
  'FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER_ERROR';
export const CLEAR_KJS_WITH_MUNICIPALITY = 'CLEAR_KJS_WITH_MUNICIPALITY';
export const SEND_DECISION = 'SEND_DECISION';
export const SEND_DECISION_START = 'SEND_DECISION_START';
export const SEND_DECISION_ERROR = 'SEND_DECISION_ERROR';

export const GET_USER_LIST_BY_KJS_MUNICIPALITY =
  'GET_USER_LIST_BY_KJS_MUNICIPALITY';
export const GET_USER_LIST_BY_KJS_MUNICIPALITY_START =
  'GET_USER_LIST_BY_KJS_MUNICIPALITY_START';
export const GET_USER_LIST_BY_KJS_MUNICIPALITY_ERROR =
  'GET_USER_LIST_BY_KJS_MUNICIPALITY_ERROR';

export const CLEAR_USER_LIST = 'CLEAR_USER_LIST';
export const GET_USER_LIST_FILTER = 'GET_USER_LIST_FILTER';
export const GET_USER_LIST_FILTER_START = 'GET_USER_LIST_FILTER_START';
export const GET_USER_LIST_FILTER_ERROR = 'GET_USER_LIST_FILTER_ERROR';
